import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';

import { ConfiguracaoCategoriaFinanceiraPadraoService } from '../../../../shared/services/apis/financas/configuracao-categoria-financeira-padrao.service';
import { ConfiguracaoCategoriaFinanceiraPadraoRequest } from '../../../../shared/services/requests/financas/configuracao-categoria-financeira-padrao.request';
import { ConfiguracaoCategoriaFinanceiraPadrao } from '../../../../shared/services/models/financas/configuracao-categoria-financeira-padrao.model';

import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { AlertCardComponent } from '../../../../shared/components/alert-card/alert-card.component';
import { ConfiguracaoCategoriaFinanceiraPadraoResponse } from '../../../../shared/services/responses/financas/configuracao-categoria-financeira-padrao.response';
import { CategoriaFinanceira } from '../../../../shared/services/models/financas/categoria-financeira.model';

@Component({
  selector: 'app-config-categoria-financeira-padrao',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    HeaderComponent,
    FooterActionComponent,
    LoadingBoxComponent,
    AlertCardComponent,
  ],
  templateUrl: './config-categoria-financeira-padrao.component.html',
  styleUrls: ['./config-categoria-financeira-padrao.component.css'],
})
export class ConfigCategoriaFinanceiraPadraoComponent implements OnInit {
  public form: FormGroup;
  public isLoading = false;
  public isSaving = false;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Financas;
  public moduloEnum = ModuloEnum.Configuracoes;

  /** Lista de categorias disponíveis para seleção nos dropdowns */
  public opcoesCategorias: CategoriaFinanceira[] = [];

  constructor(
    private fb: FormBuilder,
    private configService: ConfiguracaoCategoriaFinanceiraPadraoService,
    private alertService: AlertService,
    private router: Router
  ) {
    this.form = this.fb.group({
      // VENDA
      idCategoriaVendaFrete: [null],
      idCategoriaVendaImposto: [null],
      idCategoriaVendaDesconto: [null],
      // RECEBIMENTO
      idCategoriaRecebimentoMulta: [null],
      idCategoriaRecebimentoDesconto: [null],
      idCategoriaRecebimentoJuros: [null],
      idCategoriaRecebimentoTaxa: [null],
      idCategoriaRecebimentoPerda: [null],
      // COMPRA
      idCategoriaCompraFrete: [null],
      idCategoriaCompraDesconto: [null],
      // PAGAMENTO
      idCategoriaPagamentoMulta: [null],
      idCategoriaPagamentoJuros: [null],
      idCategoriaPagamentoDesconto: [null],
    });
  }

  ngOnInit(): void {
    this.carregarConfiguracoes();
  }

  carregarConfiguracoes(): void {
    this.isLoading = true;
    this.configService.get().subscribe({
      next: (response: ConfiguracaoCategoriaFinanceiraPadraoResponse) => {
        if (response.isError) {
          this.alertService.show('Alerta', response.errorDescription, AlertType.warning);
          this.isLoading = false;
          return;
        }

        this.opcoesCategorias = response?.listCategoriaFinanceira ?? [];

        const config: ConfiguracaoCategoriaFinanceiraPadrao = response?.configuracao;
        if (config) {
          this.form.patchValue({
            idCategoriaVendaFrete: config.idCategoriaVendaFrete,
            idCategoriaVendaImposto: config.idCategoriaVendaImposto,
            idCategoriaVendaDesconto: config.idCategoriaVendaDesconto,
            idCategoriaRecebimentoMulta: config.idCategoriaRecebimentoMulta,
            idCategoriaRecebimentoDesconto: config.idCategoriaRecebimentoDesconto,
            idCategoriaRecebimentoJuros: config.idCategoriaRecebimentoJuros,
            idCategoriaRecebimentoTaxa: config.idCategoriaRecebimentoTaxa,
            idCategoriaRecebimentoPerda: config.idCategoriaRecebimentoPerda,
            idCategoriaCompraFrete: config.idCategoriaCompraFrete,
            idCategoriaCompraDesconto: config.idCategoriaCompraDesconto,
            idCategoriaPagamentoMulta: config.idCategoriaPagamentoMulta,
            idCategoriaPagamentoJuros: config.idCategoriaPagamentoJuros,
            idCategoriaPagamentoDesconto: config.idCategoriaPagamentoDesconto,
          });
        }
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Erro ao carregar configurações de categorias', AlertType.error);
      },
    });
  }

  salvar(): void {
    const formValues = this.form.getRawValue();

    const requestData: ConfiguracaoCategoriaFinanceiraPadraoRequest = {
      idCategoriaVendaFrete: formValues.idCategoriaVendaFrete,
      idCategoriaVendaImposto: formValues.idCategoriaVendaImposto,
      idCategoriaVendaDesconto: formValues.idCategoriaVendaDesconto,
      idCategoriaRecebimentoMulta: formValues.idCategoriaRecebimentoMulta,
      idCategoriaRecebimentoDesconto: formValues.idCategoriaRecebimentoDesconto,
      idCategoriaRecebimentoJuros: formValues.idCategoriaRecebimentoJuros,
      idCategoriaRecebimentoTaxa: formValues.idCategoriaRecebimentoTaxa,
      idCategoriaRecebimentoPerda: formValues.idCategoriaRecebimentoPerda,
      idCategoriaCompraFrete: formValues.idCategoriaCompraFrete,
      idCategoriaCompraDesconto: formValues.idCategoriaCompraDesconto,
      idCategoriaPagamentoMulta: formValues.idCategoriaPagamentoMulta,
      idCategoriaPagamentoJuros: formValues.idCategoriaPagamentoJuros,
      idCategoriaPagamentoDesconto: formValues.idCategoriaPagamentoDesconto,
    };

    this.isSaving = true;
    this.configService.update(requestData).subscribe({
      next: (response: any) => {
        this.isSaving = false;
        if (response.isError) {
          this.alertService.show('Aviso!', response.errorDescription, AlertType.warning);
          return;
        }
        this.alertService.show('Sucesso', 'Configurações salvas com sucesso!', AlertType.success);
        this.router.navigate(['/configuracoes/financas']);
      },
      error: () => {
        this.isSaving = false;
        this.alertService.show('Erro', 'Erro ao conectar com a API', AlertType.error);
      },
    });
  }

  voltar(): void {
    this.router.navigate(['/configuracoes/financas']);
  }
}
